import { Table } from "flowbite-react";
import { PartnerMonthlyStatisticsDto } from "../../../types/dto/partner-monthly-statistics-dto";
import { Body16Medium } from "../../typography/Body16Medium";
import { CustomCell } from "../CustomCell";

interface Props {
  data: PartnerMonthlyStatisticsDto;
}

export const Row: React.FC<Props> = ({ data }) => {
  return (
    <Table.Row className="bg-white ">
      <Table.Cell className={`w-[824px] h-[52px] p-0 border-semantic-divider`}>
        <CustomCell>
          <div className="w-full flex justify-between">
            <Body16Medium className="text-semantic-text-body">
              {`${data.numPartnerTotal}`}
            </Body16Medium>
            <div className="flex rounded-md items-center justify-center px-[10px] py-[2px] bg-grayscale-contrast-2">
              {`+${data.numPartnerInMonth}`}
            </div>
          </div>
        </CustomCell>
      </Table.Cell>
      <Table.Cell
        className={`w-[824px] h-[52px] p-0 border-l border-semantic-divider`}
      >
        <CustomCell>
          <Body16Medium className="text-semantic-text-body">
            {`${data.numPartnerOrderedInMonth || 0}`}
          </Body16Medium>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
